var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomerSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-1.5 -1.5 48 48",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "customer-support-1--customer-headset-help-microphone-phone-support"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 28",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M22.5 42.1875c12.238125 0 17.278125 -2.525625 17.77125 -11.5659375",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 139",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.41875 30.855937499999996C3.85125 30.462187500000002 2.8125 29.025000000000002 2.8125 27.4059375L2.8125 24.84375l0 -2.5621875000000003c0 -1.618125 1.0378125 -3.05625 2.6062499999999997 -3.45 1.31625 -0.3309375 2.98125 -0.6890625 4.635 -0.8803124999999999 1.359375 -0.15656250000000002 2.551875 0.6515624999999999 2.7609375 2.0025 0.16874999999999998 1.089375 0.3103125 2.6671875000000003 0.3103125 4.890000000000001s-0.1415625 3.800625 -0.3103125 4.890000000000001c-0.2090625 1.3509375000000001 -1.4025 2.1590625 -2.7609375 2.0025 -1.65375 -0.19124999999999998 -3.31875 -0.549375 -4.6340625 -0.8803124999999999Z",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 141",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M39.58125 30.855937499999996c1.5684375 -0.39375 2.6062499999999997 -1.8309375 2.6062499999999997 -3.45l0 -2.5621875000000003 0 -2.5621875000000003c0 -1.618125 -1.0378125 -3.05625 -2.6062499999999997 -3.45 -1.31625 -0.3309375 -2.98125 -0.6890625 -4.635 -0.8803124999999999 -1.359375 -0.15656250000000002 -2.551875 0.6515624999999999 -2.7609375 2.0025C32.016562500000006 21.043125 31.875 22.621875 31.875 24.84375s0.1415625 3.800625 0.3103125 4.890000000000001c0.2090625 1.3509375000000001 1.4025 2.1590625 2.7609375 2.0025 1.65375 -0.19124999999999998 3.31875 -0.549375 4.6340625 -0.8803124999999999Z",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.84875 19.0303125C6.0234375 9.8728125 13.4784375 2.8125 22.5 2.8125s16.4765625 7.059375 17.65125 16.2178125m-5.728125 -1.0921875C33.255 12.5109375 28.359375 8.4375 22.5 8.4375s-10.754999999999999 4.0734375 -11.923125 9.500625",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 56",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.8125 39.315c0.00375 -1.6125 1.1353125000000002 -2.6765625 2.7478125 -2.72625 0.5343749999999999 -0.0159375 1.1746874999999999 -0.02625 1.9396875 -0.02625 0.8718750000000001 0 1.580625 0.013125 2.1534375000000003 0.033749999999999995 1.4653125 0.0525 2.5125 0.9956250000000001 2.53125 2.461875a24.3946875 24.3946875 0 0 1 0 0.63375c-0.01875 1.46625 -1.0659375 2.409375 -2.53125 2.461875 -0.5728125 0.020624999999999998 -1.2815625 0.033749999999999995 -2.1534375000000003 0.033749999999999995 -0.8718750000000001 0 -1.580625 -0.013125 -2.1534375000000003 -0.033749999999999995 -1.4653125 -0.0525 -2.5125 -0.9956250000000001 -2.53125 -2.461875C17.8125 39.590624999999996 17.8125 39.485625 17.8125 39.375l0 -0.06Z",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerSupport);
export default __webpack_public_path__ + "static/media/customer-support.4159beb27f6edac2c3097879a0bc5308.svg";
export { ForwardRef as ReactComponent };